import React from "react";
import {useTranslation} from "react-i18next";
import "./newAlertItem.scss";
import {AlertTypes, DescriptionModel} from "../../../../../alerts/models/alert";
import {getNotificationMessage} from "../../../../../helpers/notificationMessages";
import {DateUtils} from "../../../../../helpers/dateUtils";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface NewAlertItemProps {
    type: AlertTypes;
    date: Date | string;
    description: DescriptionModel;
    onClick: ()=> void;
}

export default function NewAlertItem(props: NewAlertItemProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="new-alert-item">
            <div className={`type ${props.type}`}/>
            <div className="description-and-chevron">
                <div>
                    <div className="description">
                        {getNotificationMessage(props.description.code, props.description.attributes)}
                    </div>
                    <div className="date">
                        <span className="label">
                            {t("alerts.newAlerts.date")}:
                        </span>
                        <span className="value">
                            {DateUtils.getFormattedTimeWithDate(props.date).replace("-", " ")}
                        </span>
                    </div>
                </div>
                <ChevronRightIcon className="chevron-right-icon" onClick={props.onClick}/>
            </div>
        </div>
    );
}

